module.exports = __webpack_public_path__ + "img/15.7fd9b825.jpg";